import { FiltroWhAlmacenMast } from './../dominio/FiltroWhAlmacenMastMast';
import { ParametroPaginacionGenerico } from 'src/app/util/ParametroPaginacionGenerico';
import { AppConfig } from './../../../../../environments/appconfig';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { WhAlmacenmast } from '../dominio/whalmacenmast';
import { UHttpsClient } from 'src/app/seguridad/seguridad/uhttpsClient';
import { DtoWhAlmacenMast } from '../dominio/DtoWhAlmacenMast';

@Injectable()
export class WhAlmacenmastService {
    private url = `${this.config.getEnv('proxy')}spring/logistica/whalmacenmast/`;
    private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    constructor(private http: UHttpsClient, private config: AppConfig) { }

    public listarActivos(): Promise<WhAlmacenmast[]> {
        return this.http.get(`${this.url}listarActivos`,{headers: this.headers})
            .toPromise()
            .then(response => {
                return response as WhAlmacenmast[];
            })
            .catch(error => []);
    }
    
    public listarActivosHuemura(tipo:string): Promise<DtoWhAlmacenMast[]> {
        return this.http.get(`${this.url}listarActivosHuemura/` + tipo ,{headers: this.headers})
            .toPromise()
            .then(response => {
                return response as DtoWhAlmacenMast[];
            })
            .catch(error => []);
    }

    

    public listarItemInventarioPaginacion(filtro: FiltroWhAlmacenMast): Promise<ParametroPaginacionGenerico> {
        filtro.paginacion.cantidadRegistrosDevolver = 300;
        filtro.paginacion.atributoOrdenar = 'almacenCodigo';
        return this.http.post(`${this.url}listarItemInventarioPaginacion`, filtro,{headers: this.headers})
            .toPromise()
            .then(response => {
                return response as ParametroPaginacionGenerico;
            })
            .catch(error => new ParametroPaginacionGenerico());
    }
}
